import { render, staticRenderFns } from "./proposals_list.vue?vue&type=template&id=ae43ea46&scoped=true&"
import script from "./proposals_list.vue?vue&type=script&lang=js&"
export * from "./proposals_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae43ea46",
  null
  
)

export default component.exports